import React from 'react';
import { authService } from 'AuthService';

import { MsalProvider } from '@azure/msal-react';

import AuthenticatedApp from './AuthenticatedApp';

const AuthenticatedAppWithMsalBroker: React.FC = () => {
  return (
    <MsalProvider instance={authService.getExperimentalPublicClientApplication()}>
      <AuthenticatedApp />
    </MsalProvider>
  );
};

export default AuthenticatedAppWithMsalBroker;
